<template>
    <div class="customer-edit-form">
        <form @submit.prevent="submit">
            <Grid>
                <Column :span="12">
                    <FormField
                        name="hook"
                        :error="error"
                        :label="schema.hook.label"
                        :required="schema.hook.required"
                    >
                        <FormInput v-model="customerData.hook" />
                    </FormField>
                </Column>
            </Grid>
            <Grid>
                <Column :span="6">
                    <button
                        type="button"
                        class="button button--medium button--fullwidth button--outlined"
                        @click.prevent="cancel"
                        v-text="$t('misc.cancel')"
                    />
                </Column>
                <Column :span="6">
                    <button
                        :disabled="loading"
                        class="button button--medium button--fullwidth"
                        v-text="$t('misc.save')"
                    />
                </Column>
            </Grid>
        </form>
    </div>
</template>

<script>
import { updateCustomer } from '../../api/customers';
import { FormField, FormInput } from '@speechki-frontend/shared/ui/forms';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';

export default {
    name: 'CustomerEditForm',
    components: {
        FormField,
        FormInput,
        Grid,
        Column,
    },

    props: {
        schema: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Object,
            required: true,
        },
    },

    emits: ['update:modelValue', 'cancel'],
    data() {
        return {
            customerData: {},
            loading: false,
            error: undefined,
        };
    },
    created() {
        this.prepareSchemaFields();
    },
    methods: {
        prepareSchemaFields() {
            Object.keys(this.schema).forEach((field) => {
                if (field === 'hook') {
                    this.customerData.hook = this.modelValue.hook;
                }
            });
        },
        async submit() {
            const { id } = this.modelValue;
            this.loading = true;

            try {
                await updateCustomer({ id, data: this.customerData });
                this.$emit('update:modelValue');
            } catch (e) {
                this.error = e;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        cancel() {
            this.$emit('cancel');
        },
    },
};
</script>

<style lang="scss" src="./CustomerEditForm.scss"></style>
